<template>
  <div class="report" v-if="load">
    <report-menu v-model="date"></report-menu>
    <div class="main">

      <h2 class="main-title">Поповнення карток</h2>
      <div class="main-header flex-justify">
        <div class="inner-addon">
        </div>
        <div class="header-right">

          <div class="select" >
            <select v-model="limit">
              <option value=10>10</option>
              <option value=20>20</option>
              <option value=40>40</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </div>
      </div>
      <section>
        <header>
          <div class="col-td">Дата</div>
          <div class="col-td">Операція</div>
          <div class="col-td">ТО</div>
          <div class="col-td">№ картки</div>
          <div class="col-td">СУМА (₴)</div>
        </header>
        <div class="table-row first-row">
          <div class="col-td">ВСЬОГО ПОПОВНЕНЬ</div>
          <div class="col-td"></div>
          <div class="col-td"></div>
          <div class="col-td"></div>
          <div class="col-td">{{total.totalSum | toCurrency }}</div>
        </div>
        <template  v-for="(tr, i) in cardAdditions" >
          <div class="table-row" :key="i">
            <div class="col-td desktop" style="width: 15%" >{{tr.dt | formatDate }}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.codeOp }}</div>
            <div class="col-td desktop"  style="width: 50%">{{tr.station }}</div>
            <div class="col-td desktop"  style="width: 15%">{{tr.cardNo }}</div>
            <div class="col-td desktop"  style="width: 10%">{{tr.summa | toCurrency }}</div>
          </div>
        </template>
      </section>
      <div v-if="total.totalCount/limit > 1" class="container">
        <paginate
            :page-count="Math.ceil(total.totalCount/limit)"
            :click-handler="changePage"
            :page-range="4"
            :margin-pages="4"
            :initial-page="page"
            :prev-text="'Попередня'"
            :next-text="'Наступна'"
            :container-class="'pagination'">
        </paginate>
        <div class="pagination-info">
          Показується з {{page * limit - limit + 1}} по {{pageTotal.countOnPage === Number(limit) ? page * limit :  total.totalCount }} із {{ total.totalCount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReportMenu from '../components/ReportMenu'
import  moment from "moment";
import Paginate from 'vuejs-paginate'
moment.defineLocale('uk', null)
export default {
  name: 'RepCards',
  components: {
    ReportMenu,
    Paginate
  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    },
    page: function () {
      // this.load = false
      this.getData()
    },
    limit: function () {
      // this.load = false
      this.getData()
      this.page = 1
    }
  },
  data() {
    return {
      load: false,
      cardAdditions: null,
      total: null,
      limit: 10,
      page: 1,
      pageTotal: {},
      date: [new Date(moment().format('YYYY, MM, 01') ), new Date() ],
    }
  },
  created() {
    this.getData()
  },
  mounted () {
    this.fillData()
  },
  methods: {
    changePage: function (pageNum){
      this.page = pageNum
    },
    fillData () {
      this.datacollection = {
        labels: ['Газ', 'A-95', 'A-92'],
        datasets: [{
          label: 'My First Dataset',
          data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt()],
          backgroundColor: [
        'rgb(255, 99, 132)',
        'rgb(54, 162, 235)',
        'rgb(255, 205, 86)'
      ],
          hoverOffset: 4}
        ]
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * (5 + 1)) + 5
    },
    getData: function (){
      this.axios.get('/userservice/v1/User/card-additions', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00',  top: this.limit, page: this.page }})
          .then(
              (resp) => {
                this.cardAdditions = resp.data.data
                this.total = resp.data.total
              })
          .catch(error => {
            console.log('error_get_data');
            console.log(error);
            this.errored = true;
          })
          .finally(() => (
              this.load = true)
          )
    },
  }
}
</script>
<style>

</style>